import React from 'react';
import {useLang} from "../../context/LanguageContext";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import useSubscriptions from "../../hooks/useSubscriptions";
import SubscriptionCard from "../../components/SubscriptionCard";
import Loading from "../../components/Loading";
import {FaArrowLeft} from "react-icons/fa";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import SubscriptionForm3ds from "../../components/SubscriptionForm3ds";


const BuySubscriptionPage = () => {
    const { t } = useLang();
    const { id } = useParams();
    const subscriptions = useSubscriptions();
    const [subscription, setSubscription] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        const subscriptionChosen = subscriptions.find(sub => sub.id === id);
        if(subscriptionChosen){
            setSubscription(subscriptionChosen);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, subscriptions]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (subscription === null) {
                navigate('/')
            }
        }, 5000);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscription]);


    if(!subscription){
        return (
            <div className="relative min-h-screen bg-[#34495e] p-5">
                <Loading />
            </div>
        )
    }

    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

    return (
        <div className="relative min-h-screen bg-[#34495e] p-5">
            <button
                onClick={() => navigate(-1)}
                className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
            >
                <FaArrowLeft/>
                <span className="text-white">{t('btn.back')}</span>
            </button>

            <div className="max-w-[700px] mx-auto space-y-6 mt-16">
                <SubscriptionCard sub={subscription} showBuy={false}/>
            </div>

            <div className="max-w-[700px] mx-auto space-y-6 mt-8">
                <Elements stripe={stripePromise}>
                    <SubscriptionForm3ds priceId={subscription.priceId}/>
                </Elements>
            </div>


        </div>
    )
}

export default BuySubscriptionPage;